import {
  ITypeaheadItem,
  TTypeaheadFormatter,
  EItemButtons,
  EUserType,
} from '../domain/typeahead.interfaces';
import _ from 'lodash';

export function typeaheadItemFormatter(
  configObject: ITypeaheadItem,
  option: any,
  userType?: EUserType,
  unallowedButtons?: EItemButtons[],
) {
  let optionFormatted: ITypeaheadItem = {
    original: option,
    userType: userType !== undefined ? userType : EUserType.USER,
    unallowedButtons: unallowedButtons !== undefined ? unallowedButtons : [],
  } as ITypeaheadItem;

  Object.keys(configObject).forEach(
    (configKey: TTypeaheadFormatter | string) => {
      if (typeof getValueKey(configObject, configKey) === 'string') {
        optionFormatted = {
          ...optionFormatted,
          ...{
            [configKey]: _.get(option, getValueKey(configObject, configKey)),
          },
        };
      } else {
        let complexDataString = '';
        getValueKey(configObject, configKey).map((key: string) => {
          return (complexDataString += !!_.get(option, key)
            ? ` ${_.get(option, key)}`
            : '');
        });
        optionFormatted = {
          ...optionFormatted,
          ...{
            [configKey]: complexDataString,
          },
        };
      }
    },
  );
  return optionFormatted;
}

export function typeaheadOptionsFormatter(
  configObject: ITypeaheadItem,
  options: any[],
): ITypeaheadItem[] {
  let resultTypeaheadFormat: ITypeaheadItem[] = [];

  options.forEach(option => {
    const item = typeaheadItemFormatter(configObject, option);
    resultTypeaheadFormat = [...resultTypeaheadFormat, item];
  });

  return resultTypeaheadFormat;
}

export function transformToPlainText(html: string): string {
  html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
  html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
  html = html.replace(/<\/div>/gi, '\n');
  html = html.replace(/<\/li>/gi, '\n');
  html = html.replace(/<li>/gi, '  *  ');
  html = html.replace(/<\/ul>/gi, '\n');
  html = html.replace(/<\/p>/gi, '\n');
  html = html.replace(/<br\s*[/]?>/gi, '\n');
  html = html.replace(/<[^>]+>/gi, '');
  return html;
}

export function trimEndNewLine(text: string): string {
  const newText = text.replace(/^\s+|\s+$/g, '');
  return newText;
}

export function replaceNewLineWithBR(text: string): string {
  const newText = text.replace(/\n/g, '<br/>');
  return newText;
}

export function objectFromQueryParams(queryPairs: string[]) {
  if (!queryPairs.length) {
    return;
  }
  const queryObject: any = {};

  queryPairs.forEach((pair: any) => {
    pair = pair.split('=');
    queryObject[pair[0] as string] = decodeURIComponent(pair[1] || '');
  });

  return queryObject;
}

export function urlFormatter(url: string) {
  return `//${url.indexOf(':') >= 0 ? url.substr(url.indexOf(':') + 1) : url}`;
}

export function extractNameFromUrl(url: string) {
  let result;
  let match;
  if (
    (match = url.match(
      // eslint-disable-next-line
      /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n\?\=]+)/im,
    ))
  ) {
    result = match[1];
    // eslint-disable-next-line
    if ((match = result.match(/^[^\.]+\.(.+\..+)$/))) {
      result = match[1];
    }
  }
  return result;
}

function getValueKey(
  configObject: ITypeaheadItem & any,
  configKey: TTypeaheadFormatter | string,
) {
  return configObject[configKey];
}
